// extracted by mini-css-extract-plugin
export var logo = "_i8-2";
export var logoWrapper = "_i8-1";
export var strip = "_i8-0";